import styles from "./Services.module.css";

export default function Services() {
  return (
    <section className={styles.servicesSection}>
      <h1 className={styles.title}>Work in progress</h1>
      <p className={styles.subtitle}>I’m currently building this page.</p>
    </section>
  );
}
